import { useCallback, useEffect, useRef, useState } from "react";
import { requestJson } from './requestJson';
import { SESSION_EVENT } from './sessionEvents';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const json = async (r) => {
  if (!r.ok) throw new Error((await r.json().catch(() => ({}))).detail || `Request failed (${r.status})`);
  return r.json();
};
const send = (url, method, body) => fetch(url, { method, credentials:'include', headers: { "Content-Type": "application/json" }, body: body && JSON.stringify(body) }).then(json);

export const workspacesApi = {
  list: (signal) => requestJson(`${API}/workspaces`, {cache:'no-store',signal}, {retries:1,label:'Workspace loading'}),
  edit: (id, body) => send(`${API}/workspaces/${id}`, "PATCH", body),
  async logo(id, file) {
    const fd = new FormData();
    fd.append("file", file);
    return fetch(`${API}/workspaces/${id}/logo`, { method: "POST", credentials:'include', body: fd }).then(json);
  },
  removeLogo: (id) => send(`${API}/workspaces/${id}/logo`, "DELETE"),
};

export const logoUrl = (ws) => (ws?.logo ? `${process.env.REACT_APP_BACKEND_URL}${ws.logo}` : null);

export function useWorkspaces() {
  const [items, setItems] = useState(null);
  const [error,setError] = useState('');
  const active=useRef(null),sequence=useRef(0);
  const refresh=useCallback(async()=>{
    active.current?.abort();const controller=new AbortController();active.current=controller;
    const request=++sequence.current;setItems(null);setError('');
    try{
      const value=await workspacesApi.list(controller.signal);
      if(!Array.isArray(value))throw new Error('Workspace response was not valid. Please retry.');
      if(request===sequence.current)setItems(value);
    }catch(e){if(request===sequence.current&&!controller.signal.aborted){setError(e.message);setItems([]);}}
  },[]);
  useEffect(()=>{refresh();window.addEventListener(SESSION_EVENT,refresh);return()=>{
    sequence.current++;active.current?.abort();window.removeEventListener(SESSION_EVENT,refresh);
  };},[refresh]);
  return { items, error, refresh };
}
